import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const ReporteVendedores = () => {
    const [canjeData, setCanjeData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    const [selectedCanje, setSelectedCanje] = useState([]);
    const dt = useRef(null);

    useEffect(() => {
        fetchCanje();
    }, []);

    const fetchCanje = async () => {
        try {
            setLoading(true);

            // Obtener número de cédula del empleado autenticado desde localStorage
            const cedulaEmpleado = localStorage.getItem('cedulaEmpleado');

            const response = await fetch(`/api/puntuacion/canjepremio/findbycedula/${cedulaEmpleado}`);
            const data = await response.json();
            
            const formattedData = data.map(item => ({
                id: item.id,
                nombrePremio: item.premio ? item.premio.nombre : 'Desconocido',
                descripcionPremio: item.premio ? item.premio.descripcion : 'Sin descripción',
                canje_confirmado: item.canje_confirmado ?? 'No confirmado',
                fecha: item.fecha ? new Date(item.fecha).toLocaleDateString('es-ES') : null,
            }));

            setCanjeData(formattedData);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching canje:', error);
            setLoading(false);
        }
    };

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const exportExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(selectedCanje.length > 0 ? selectedCanje : canjeData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Canjes');
        XLSX.writeFile(workbook, 'canjes.xlsx');
    };

    const exportPDF = () => {
        const doc = new jsPDF();
        doc.autoTable({
            head: [['ID', 'Nombre del Premio', 'Descripción del Premio', 'Canje Confirmado', 'Fecha']],
            body: (selectedCanje.length > 0 ? selectedCanje : canjeData).map(item => [
                item.id, item.nombrePremio, item.descripcionPremio, item.canje_confirmado, item.fecha
            ])
        });
        doc.save('canjes.pdf');
    };

    const header = (
        <div className="table-header">
            <h1>Reporte para Vendedores</h1>
            <div className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="text" placeholder="Buscar en todos los campos" 
                           value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} />
            </div>
            <div>
                <Button label="Exportar CSV" icon="pi pi-file-o" onClick={exportCSV} />
                <Button label="Exportar Excel" icon="pi pi-file-excel" onClick={exportExcel} className="p-button-success" />
                <Button label="Exportar PDF" icon="pi pi-file-pdf" onClick={exportPDF} className="p-button-danger" />
            </div>
        </div>
    );

    return (
        <div className="reporte-vendedores">
            <DataTable ref={dt} value={canjeData} loading={loading} emptyMessage="No hay datos disponibles"
                       header={header} globalFilter={globalFilter}
                       selection={selectedCanje} onSelectionChange={e => setSelectedCanje(e.value)}>
                <Column selectionMode="multiple" headerStyle={{ width: '3em' }} />
                <Column field="fecha" header="Fecha" sortable />
                <Column field="nombrePremio" header="Nombre del Premio" sortable />
                <Column field="descripcionPremio" header="Descripción del Premio" sortable />
                <Column field="canje_confirmado" header="Canje Confirmado" sortable />
            </DataTable>
        </div>
    );
};

export default ReporteVendedores;
